import { initialState } from './ai-experience-context-plugin';
import type { AIExperienceContextAction, AIExperienceContextPluginState } from './types';

export function reducer({
	state,
	action,
}: {
	action: AIExperienceContextAction;
	state: AIExperienceContextPluginState;
}): AIExperienceContextPluginState {
	switch (action.type) {
		case 'RESET_EXPERIENCE':
			return initialState;
		default:
			return state;
	}
}
